import PollIcon from '@material-ui/icons/ViewList';

import PollList from './PollList';
import {PollCreate} from "./PollCreate";
import PollEdit from "./PollEdit";

export default {
  list: PollList,
  create: PollCreate,
  edit: PollEdit,
  icon: PollIcon,
};
